import values from 'lodash/fp/values'
import PropTypes from 'prop-types'


const constants = {
    DEFAULT: '',
    ERROR: 'RequestApplications/REQUEST_APPLICATIONS_ERROR',
    PENDING: 'RequestApplications/REQUEST_APPLICATIONS_PENDING',
    SUCCESS: 'RequestApplications/REQUEST_APPLICATIONS_SUCCESS'
}

export const types = PropTypes.oneOf(values(constants))

export default constants
